<template>
	<nk-page commercialAccess="System" :policyClaims="['General_FrequentDescription_Management']">
		<div class="h-100 d-flex flex-column">
			<FrequentDescriptionsList ref="frequentDescsList" class="h-grow-lock" :options="options" />
		</div>
	</nk-page>
</template>
<script>
	import FrequentDescriptionsList from '~/components/form/frequent-descriptions/frequent-descriptions-list.vue'
	import $sc from '~/plugins/shortcut.collection.js'
	import { mapActions } from 'vuex'
	import { post } from '~/plugins/nikan-api'
	import Endpoints from '@nikan/endpoints'
	import dialog from '~/plugins/nikan-dialog-plugin'
	export default {
		modal: {
			size: 'md',
			stateUID: 'frequent-descriptions',
		},
		components: {
			FrequentDescriptionsList,
		},
		props: {
			data: { type: Object },
			options: { type: Object },
		},
		data() {
			return {
				addClicked: false,
				settings: {},
				selectedRow: null,
			}
		},
		mounted() {
			this.prepareWindow(`${this.$t('frequent-descriptions.title')} : ${this.options.entityTitle}`, [
				{
					title: this.$t('save'),
					shortcut: $sc.find('save'),
					icon: 'save',
					isPrimary: false,
					handle(button, page, e) {
						this.saveNewDescriptions()
					},
					policyClaims: 'General_FrequentDescription_Edit',
				},
			])
		},
		methods: {
			...mapActions({
				refreshFrequentDescription: 'frequentdescriptions/refresh',
			}),
			saveNewDescriptions() {
				return new Promise((resolve, reject) => {
					this.$refs.frequentDescsList.newDescriptions().then((data) => {
						var wait = this.$wait(this.$refs.frequentDescsList.$el)
						post(Endpoints.getUrl('frequentDescriptions.modify'), { items: data })
							.then((response) => {
								wait.end()
								if (response.success) {
									this.refreshFrequentDescription({
										entityId: this.options.entityId,
										entityType: this.options.entityType,
										force: true
									})
									this.$refs.frequentDescsList.close()
									resolve(response.data)
									this.$toast(this.$t('msg.create-success'), { type: 'success' })
								}
							})
							.catch((err) => {
								reject(err)
								wait.end()
							})
					})
				})
			},
		},
	}
</script>
<style>
	.freq-desc-title {
		text-align: center;
		font-size: 1.2rem;
		margin: auto;
		background-color: #fffef6;
		margin: -5px -10px 20px -10px;
		border-bottom: 1px dashed #ffc400;
		color: #a27c00;
		padding: 10px;
	}
</style>
